import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';

export const Accordion = ({ type = 'single', children, value, onValueChange, collapsible = true }) => {
  const isSingle = type === 'single';

  return <div className="space-y-2">{React.Children.map(children, (child) => {
    if (!React.isValidElement(child)) return null;
    const childValue = child.props.value;
    const isOpen = value === childValue;

    return React.cloneElement(child, {
      open: isOpen,
      onToggle: () =>
        onValueChange?.(isOpen && collapsible ? '' : childValue),
    });
  })}</div>;
};

export const AccordionItem = ({ children, value, open, onToggle }) => {
  return (
    <div className="border rounded-md">
      {React.Children.map(children, (child) => {
        if (!React.isValidElement(child)) return null;
        return React.cloneElement(child, {
          isOpen: open,
          onClick: onToggle,
          open, // for AccordionTrigger and AccordionContent
        });
      })}
    </div>
  );
};


export const AccordionTrigger = ({ children, onClick, isOpen }) => (
  <button
    type="button"
    onClick={onClick}
    className="w-full flex items-center justify-between px-4 py-2 bg-muted text-left font-medium hover:bg-muted/80 transition"
  >
    <span>{children}</span>
    <motion.div animate={{ rotate: isOpen ? 180 : 0 }} transition={{ duration: 0.2 }}>
      <ChevronDown size={16} />
    </motion.div>
  </button>
);


export const AccordionContent = ({ children, open }) => (
  <AnimatePresence initial={false}>
    {open && (
      <motion.div
        initial={{ height: 0, opacity: 0 }}
        animate={{ height: 'auto', opacity: 1 }}
        exit={{ height: 0, opacity: 0 }}
        transition={{ duration: 0.2 }}
        className="overflow-hidden px-4 py-3 border-t text-sm text-muted-foreground bg-muted/10"
      >
        {children}
      </motion.div>
    )}
  </AnimatePresence>
);